"use client";
import React, { useEffect, useState } from "react";
import { useMovementDetection } from "@/components/useMouseMovement";
import { NavSearch } from "@/components/nav-ulife-client-component";

const NavSearchLoader = ({ clasName, onEnter, colorStyle }: { clasName?: string; onEnter?: () => void; colorStyle: any }) => {
    const [showComponent, setShowComponent] = useState(false);
    const hasInteracted = useMovementDetection();
    useEffect(() => {
        if (hasInteracted) {
            setShowComponent(true);
        }
    }, [hasInteracted]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowComponent(true);
        }, 1000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return showComponent ? <NavSearch clasName={clasName} onEnter={onEnter} colorStyle={colorStyle} /> : null;
};

export default NavSearchLoader;
